import { Component, Input, OnInit } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { AskOptions } from '../modal.model';

@Component({
  selector: 'sb-ask-modal',
  templateUrl: './sb-ask-modal.component.html',
  styleUrls: ['./sb-ask-modal.component.scss'],
  standalone: false,
})
export class SbAskModalComponent implements OnInit {
  options: AskOptions<any>;
  @Input()
  templateId: string;

  ngOnInit() {
    this.options = this.state.options.get(this.templateId) as AskOptions<any>;
  }

  constructor(private state: SbModalState) {}

  onOption(c: string) {
    this.state.modals.get(this.templateId).close(c);
  }
}
